/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { GetChildSupportPaymentResponseDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class AchChildSupportPaymentsClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags AchChildSupportPayment
   * @name AchChildSupportPaymentGet
   * @summary Returns ach child support payment information
   * @request GET:/achChildSupportPayments/{achPaymentUniqueId}
   */
  achChildSupportPaymentGet = (
    achPaymentUniqueId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<GetChildSupportPaymentResponseDto, any>({
      path: `/achChildSupportPayments/${achPaymentUniqueId}`,
      method: "GET",
      format: "json",
      ...params,
    });
}
